import React from "react";
import { NavLink, useLocation } from "react-router-dom";

function SidebarNav() {
  const location = useLocation();
  const isMarketplaceSetupActive =
    location.pathname.startsWith("/marketplaceCampaign") ||
    location.pathname.startsWith("/marketplaceOrderTimeouts") ||
    location.pathname.startsWith("/marketplaceZones") ||
    location.pathname.startsWith("/marketplaceDeliveryFees");

  const isRiderSectionActive =
    location.pathname.startsWith("/marketplaceRider") ||
    location.pathname.startsWith("/marketplaceRiderShifts") ||
    location.pathname.startsWith("/marketplacePerformance/riders") ||
    location.pathname.startsWith("/marketplacePerformance/timeline");

  const isCompanySectionActive =
    location.pathname.startsWith("/company") ||
    location.pathname.startsWith("/marketplaceRestaurant") ||
    location.pathname.startsWith("/marketplacePerformance/overview");

  return (
    <div className="menu mt-4">
      <div className="menu-header">Navigation</div>

      {/* Dashboard */}
      <div
        className={`menu-item ${location.pathname.startsWith("/dashboard") ? "active" : ""
          }`}
      >
        <NavLink to="/dashboard" className="menu-link" end>
          <div className="menu-icon">
            <i className="fa fa-sitemap"></i>
          </div>
          <div className="menu-text">Dashboard</div>
        </NavLink>
      </div>

      {/* Revenue */}
      <div
        className={`menu-item ${location.pathname.startsWith("/revenue") ? "active" : ""
          }`}
      >
        <NavLink to="/revenue" className="menu-link" end>
          <div className="menu-icon">
            <i className="fa fa-chart-line"></i>
          </div>
          <div className="menu-text">Revenue</div>
        </NavLink>
      </div>

      {/* Companies Management */}
      <div className={`menu-item has-sub ${isCompanySectionActive ? "active" : ""}`}>
        <div className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-building"></i>
          </div>
          <div className="menu-text">Companies</div>
          <div className="menu-caret"></div>
        </div>
        <div className="menu-submenu">
          <div
            className={`menu-item ${location.pathname.startsWith("/company") ? "active" : ""}`}
          >
            <NavLink to="/company/manageCompany" className="menu-link">
              All Companies
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRestaurant/settlements") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRestaurant/settlements" className="menu-link">
              Restaurant Settlements
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplacePerformance/overview") ? "active" : ""}`}
          >
            <NavLink to="/marketplacePerformance/overview" className="menu-link">
              Go Fatafat Performance
            </NavLink>
          </div>
        </div>
      </div>

      {/* Go Fatafat Setup */}
      <div className={`menu-item has-sub ${isMarketplaceSetupActive ? "active" : ""}`}>
        <div className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-store"></i>
          </div>
          <div className="menu-text">Go Fatafat Setup</div>
          <div className="menu-caret"></div>
        </div>
        <div className="menu-submenu">
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceCampaign") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceCampaign/manageCampaigns" className="menu-link">
              Campaigns
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceDeliveryFees") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceDeliveryFees/manageSlabs" className="menu-link">
              Delivery Fee Slabs
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceZones") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceZones/manageZones" className="menu-link">
              Service Zones
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname === "/marketplaceOrderTimeouts/settings" ? "active" : ""}`}
          >
            <NavLink to="/marketplaceOrderTimeouts/settings" className="menu-link">
              Settings
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname === "/marketplaceOrderTimeouts/penalties" ? "active" : ""}`}
          >
            <NavLink to="/marketplaceOrderTimeouts/penalties" className="menu-link">
              Penalties
            </NavLink>
          </div>
        </div>
      </div>

      {/* Go Fatafat Riders */}
      <div className={`menu-item has-sub ${isRiderSectionActive ? "active" : ""}`}>
        <div className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-motorcycle"></i>
          </div>
          <div className="menu-text">Go Fatafat Riders</div>
          <div className="menu-caret"></div>
        </div>
        <div className="menu-submenu">
          <div
            className={`menu-item ${location.pathname === "/marketplaceRider/manageRiders" ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/manageRiders" className="menu-link">
              All Riders
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/liveDispatch") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/liveDispatch" className="menu-link">
              Live Dispatch
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplacePerformance/riders") ? "active" : ""}`}
          >
            <NavLink to="/marketplacePerformance/riders" className="menu-link">
              Rider Performance
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplacePerformance/timeline") ? "active" : ""}`}
          >
            <NavLink to="/marketplacePerformance/timeline" className="menu-link">
              Order Timeline
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/remittances") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/remittances" className="menu-link">
              COD Remittances
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/creditLimits") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/creditLimits" className="menu-link">
              Credit Limits
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/performanceRules") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/performanceRules" className="menu-link">
              Performance Rules
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/violationHistory") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/violationHistory" className="menu-link">
              Violation History
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRider/payouts") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRider/payouts" className="menu-link">
              Earnings Payouts
            </NavLink>
          </div>
          <div
            className={`menu-item ${location.pathname.startsWith("/marketplaceRiderShifts") ? "active" : ""}`}
          >
            <NavLink to="/marketplaceRiderShifts/manageShifts" className="menu-link">
              Shift Slots
            </NavLink>
          </div>
        </div>
      </div>

      {/* Global Customers */}
      <div
        className={`menu-item ${location.pathname.startsWith("/customer") ? "active" : ""
          }`}
      >
        <NavLink to="/customer/marketplaceCustomers" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-users"></i>
          </div>
          <div className="menu-text">Global Customers</div>
        </NavLink>
      </div>

      {/* Payment Providers */}
      <div
        className={`menu-item ${location.pathname.startsWith("/paymentProvider") ? "active" : ""
          }`}
      >
        <NavLink to="/paymentProvider/managePaymentProviders" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-credit-card"></i>
          </div>
          <div className="menu-text">Online Payment Methods</div>
        </NavLink>
      </div>

      {/* Payment Gateway Platforms */}
      <div
        className={`menu-item ${location.pathname.startsWith("/paymentGatewayPlatform") ? "active" : ""
          }`}
      >
        <NavLink to="/paymentGatewayPlatform/managePaymentGatewayPlatforms" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-building-columns"></i>
          </div>
          <div className="menu-text">Payment Gateways</div>
        </NavLink>
      </div>

      {/* Allergens */}
      <div
        className={`menu-item ${location.pathname.startsWith("/allergen") ? "active" : ""
          }`}
      >
        <NavLink to="/allergen/manageAllergens" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-exclamation-triangle"></i>
          </div>
          <div className="menu-text">Allergens</div>
        </NavLink>
      </div>

      {/* Units */}
      <div
        className={`menu-item ${location.pathname.startsWith("/units") ? "active" : ""
          }`}
      >
        <NavLink to="/units/manageUnits" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-ruler-combined"></i>
          </div>
          <div className="menu-text">Units</div>
        </NavLink>
      </div>

      <div
        className={`menu-item ${location.pathname.startsWith("/resturantCategory") ? "active" : ""
          }`}
      >
        <NavLink to="/resturantCategory/manageResturantCategories" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-layer-group"></i>
          </div>
          <div className="menu-text">Resturant Categories</div>
        </NavLink>
      </div>

      <div
        className={`menu-item ${location.pathname.startsWith("/appReleases") ? "active" : ""
          }`}
      >
        <NavLink to="/appReleases/manageAppReleases" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-download"></i>
          </div>
          <div className="menu-text">App Releases</div>
        </NavLink>
      </div>

      {/* Subscription System */}
      <div className="menu-header">Subscription System</div>

      {/* Packages */}
      <div
        className={`menu-item ${location.pathname.startsWith("/packages") ? "active" : ""
          }`}
      >
        <NavLink to="/packages/managePackages" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-box"></i>
          </div>
          <div className="menu-text">Packages</div>
        </NavLink>
      </div>

      {/* Addons */}
      <div
        className={`menu-item ${location.pathname.startsWith("/addons") ? "active" : ""
          }`}
      >
        <NavLink to="/addons/manageAddons" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-puzzle-piece"></i>
          </div>
          <div className="menu-text">Addons</div>
        </NavLink>
      </div>

      <div className="menu-header">Billing</div>

      <div
        className={`menu-item ${location.pathname.startsWith("/billing/manageBankAccounts") ? "active" : ""
          }`}
      >
        <NavLink to="/billing/manageBankAccounts" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-building-columns"></i>
          </div>
          <div className="menu-text">Bank Accounts</div>
        </NavLink>
      </div>

      <div
        className={`menu-item ${location.pathname.startsWith("/billing/paymentSettings") ? "active" : ""
          }`}
      >
        <NavLink to="/billing/paymentSettings" className="menu-link">
          <div className="menu-icon">
            <i className="fa-brands fa-stripe"></i>
          </div>
          <div className="menu-text">Payment Settings</div>
        </NavLink>
      </div>

      <div className="menu-header">Support</div>

      <div
        className={`menu-item ${location.pathname.startsWith("/support/supportSettings") ? "active" : ""
          }`}
      >
        <NavLink to="/support/supportSettings" className="menu-link">
          <div className="menu-icon">
            <i className="fa-solid fa-headset"></i>
          </div>
          <div className="menu-text">Support Details</div>
        </NavLink>
      </div>
    </div>
  );
}

export default SidebarNav;
